import React from 'react'
import styles from './home.module.css'



import NameComponent from '../../components/nameComponent/NameComponent'
import ContentComponent from '../../components/contentComponent/ContentComponent'

const home = ()=>{
    return(
    <div className={styles.homeContainer}>
        {/* Name */}
       <NameComponent/>
        {/*Content */}
       <ContentComponent/>
    </div>

    )
}
export default home;